import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

interface GetCarriersRequest {
  buildingId: number
}

interface Carrier {
  id: number
  code: number
  name: string
}

interface GetDeliveryAccessCodesResponse {
  carriers: Carrier[]
}

export const getCarriersQueryKey = (data: GetCarriersRequest) => ['useGetCarriers', data]

export const getCarriers = async (params: GetCarriersRequest): Promise<Carrier[]> => {
  const response = await authAPI.get<GetDeliveryAccessCodesResponse>(`/carrier`, { params })
  return response.data.carriers || []
}

export const useGetCarriers = (data: GetCarriersRequest) => {
  return useQuery({
    enabled: data.buildingId > 0,
    placeholderData: keepPreviousData,
    queryFn: () => getCarriers(data),
    queryKey: getCarriersQueryKey(data),
  })
}
